import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Gallery from "@/pages/Gallery";
import Dashboard from "@/pages/Dashboard";
import Wizard from "@/pages/Wizard";
import AdminQueue from "@/pages/admin/AdminQueue";
import AdminDetail from "@/pages/admin/AdminDetail";
import AdminEventSettings from "@/pages/admin/AdminEventSettings";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <div className="animate-pulse text-primary font-serif text-2xl">…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/honour" element={<Gallery />} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/apply" element={<Protected><Wizard /></Protected>} />
              <Route path="/admin" element={<Protected adminOnly><AdminQueue /></Protected>} />
              <Route path="/admin/applications/:id" element={<Protected adminOnly><AdminDetail /></Protected>} />
              <Route path="/admin/event" element={<Protected adminOnly><AdminEventSettings /></Protected>} />
              <Route path="/admin/analytics" element={<Protected adminOnly><AdminAnalytics /></Protected>} />
              <Route path="/admin/settings" element={<Protected adminOnly><AdminSettings /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
